import * as React from 'react';
import CalendarImage from '../../images/community-events-section-hero.png';
import CalendarImageMobile from '../../images/community-events-section-hero-mobile.png';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Parser from 'html-react-parser';

const CommunityEvents = () => {
    const events = [
        {
            title: '2023 USCHA',
            date: '9/6/2023',
            description:
                'Join us at the 2023 US Conference on HIV/AIDS (USCHA), the premier HIV conference...'
        },
        {
            title: 'IDWEEK 2023',
            date: '10/11/2023',
            description: "We're excited to connect with leaders in infectious disease care..."
        },
        {
            title: 'EACS Conference',
            date: '10/18/2023',
            description: 'The EACS 2023 theme of "It\'s time to revisit!" brings clinicians, scientists, community organizations...'
        }
    ];
    return (
        <>
            <Container className='section last community-events'>
                <Row>
                    <Col xs={10} className='mx-auto'>
                        <h2 className='title'>Community events</h2>
                        <Container>
                            <Row>
                                <Col
                                    xs={12}
                                    md={{ span: 5, order: 2 }}
                                    className='px-0 muted-yellow justify-content-center d-flex mb-2 mb-md-0'
                                >
                                    <img
                                        className='community d-none d-md-block'
                                        src={CalendarImage}
                                        alt='Two women outside in the woods'
                                    />
                                    <img
                                        className='community d-block d-md-none w-100'
                                        src={CalendarImageMobile}
                                        alt='Two women outside in the woods'
                                    />
                                </Col>
                                <Col md={{ span: 7, order: 1 }} className='blush pb-4'>
                                    <Container>
                                        <Row>
                                            <Col sm={12}>
                                                <span className='heading text-uppercase'>
                                                    Our upcoming programs &amp; events
                                                </span>
                                            </Col>
                                            {events.map((event, index) => (
                                                <Col sm={12} className='event' key={index}>
                                                    <a href='/community-involvement/events/'>
                                                        <span className='date'>{event.date}</span>
                                                        <span className='title'>
                                                            {Parser(event.title)}
                                                        </span>
                                                        <i className='fa fa-chevron-right big'></i>
                                                        <p className='description '>
                                                            {Parser(event.description)}
                                                        </p>
                                                    </a>
                                                </Col>
                                            ))}
                                            <Col sm={12}>
                                                <a
                                                    className='btn full-calendar'
                                                    href='/community-involvement/events'
                                                >
                                                    View full calendar
                                                </a>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CommunityEvents;
